import { Input } from "antd";
import type React from "react";
import { useCallback } from "react";
import { useUpdateListFixture } from "../../hooks";
import type { ColumnComponentProperties } from "../../types";

export const FixtureNameColumn = (properties: ColumnComponentProperties) => {
  const { mutate: updateFixture, isPending } = useUpdateListFixture();

  const updateFixtureCallback = useCallback(
    (value: string) => {
      updateFixture({
        fixtureId: properties.fixtureId,
        upsertData: {
          nameLocal: value,
        },
      });
    },
    [properties.fixtureId, updateFixture],
  );

  const handlePressEnter = useCallback(
    (e: React.KeyboardEvent<HTMLInputElement>) => {
      const target = e.target as HTMLInputElement;
      updateFixtureCallback(target.value);
    },
    [updateFixtureCallback],
  );

  const handleOnBlur = useCallback(
    (e: { target: { value: string } }) => {
      updateFixtureCallback(e.target.value);
    },
    [updateFixtureCallback],
  );

  if (properties.editMode) {
    return (
      <Input
        onBlur={handleOnBlur}
        disabled={isPending}
        style={{ width: "100%" }}
        maxLength={150}
        onPressEnter={handlePressEnter}
        defaultValue={properties.value}
      />
    );
  }

  return properties.value;
};
